// extracted by mini-css-extract-plugin
module.exports = {"canvas":"chickenCanvas_canvas__zRbUl"};